import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import CustomSelect from '../../../ui/CustomSelect';

const EDUCATION_LEVEL_OPTIONS = [
  { value: 'sd', label: 'SD' },
  { value: 'smp', label: 'SMP' },
  { value: 'sma', label: 'SMA/SMK' },
  { value: 'd3', label: 'D3' },
  { value: 's1', label: 'S1' },
  { value: 's2', label: 'S2' },
  { value: 's3', label: 'S3' },
];

export default function EducationTab({ formData, setFormData }) {
  const addEducation = () => {
    setFormData(prev => ({
      ...prev,
      education_history: [
        ...prev.education_history,
        {
          level: '',
          institution: '',
          major: '',
          year_start: '',
          year_end: '',
          gpa: '',
          degree: '',
        },
      ],
    }));
  };

  const updateEducation = (index, field, value) => {
    const history = [...formData.education_history];
    history[index][field] = value;
    setFormData(prev => ({ ...prev, education_history: history }));
  };

  const removeEducation = index => {
    setFormData(prev => ({
      ...prev,
      education_history: prev.education_history.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Data Pendidikan</h3>
        <p className="text-gray-500 text-sm">Riwayat pendidikan formal pegawai</p>
      </div>

      <AnimatePresence>
        {formData.education_history.map((edu, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="border-2 rounded-lg p-4 space-y-3"
          >
            <div className="flex justify-between items-start">
              <h4 className="font-medium">Pendidikan #{index + 1}</h4>
              <button
                type="button"
                onClick={() => removeEducation(index)}
                className="text-red-500 hover:text-red-700 transition-colors duration-300"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
            <div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Jenjang</label>
                <CustomSelect
                  value={edu.level}
                  onChange={v => updateEducation(index, 'level', v)}
                  placeholder="Pilih"
                  width="w-full"
                  options={EDUCATION_LEVEL_OPTIONS}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nama Institusi
                </label>
                <input
                  type="text"
                  value={edu.institution}
                  onChange={e => updateEducation(index, 'institution', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Jurusan</label>
                <input
                  type="text"
                  value={edu.major}
                  onChange={e => updateEducation(index, 'major', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tahun Lulus</label>
                <input
                  type="text"
                  value={edu.year_end}
                  onChange={e => updateEducation(index, 'year_end', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>

      <motion.button
        type="button"
        onClick={addEducation}
        whileHover={{ scale: 1.01 }}
        whileTap={{ scale: 0.98 }}
        className="w-full py-2 border-2 border-dashed rounded-lg text-gray-600 hover:border-emerald-500 hover:text-emerald-600 hover:bg-emerald-50 flex items-center justify-center gap-2 transition-colors duration-300"
      >
        <Plus className="w-4 h-4" /> Tambah Riwayat Pendidikan
      </motion.button>
    </div>
  );
}
